module.exports = __webpack_public_path__ + "static/media/starterguidestep6.a0a63f91.png";